<template>
  <div id="top" class="header">
    <nav id="navbar" class="navbar noselect">
      <div class="logo" :class="{'logo-show': showOverlay}">
        <router-link class="link" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1357.19 428.61" :fill="colorAttr()" class="svg-logo" @click="toTop()"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M589.49,140.12c36.48,0,53,15.08,53,41,0,17.73-10.19,31-26.49,35.46V217c10.19,3.67,15.08,9.79,21.81,28.13l14.47,40.15H619.66L608,250.78c-5.3-15.48-11.21-21-25.48-21H566.05v55.44h-30V140.12ZM566.05,206h21.2c18.14,0,25.07-8.16,25.07-21.4,0-14.07-9.58-20.18-26.7-20.18H566.05Z"/><path class="cls-1" d="M760.08,233.46c0,33.63-20.58,55-53,55s-53-21.4-53-55,20.58-55,53-55S760.08,199.83,760.08,233.46Zm-76,0c0,20.18,9,33,23,33s23-12.84,23-33-9-33-23-33S684.06,213.28,684.06,233.46Z"/><path class="cls-1" d="M862.65,219.4v37.5c0,13,1,21.4,2.85,28.33H839.82a59.08,59.08,0,0,1-1.43-13.86H838c-7.75,11-19.37,16.3-33.63,16.3-22,0-35.26-13.45-35.26-31.38,0-16.92,10.19-28.33,40.15-33,7.74-1.22,19.36-2.45,25.88-2.85v-3.67c0-13.05-6.93-18.34-16.91-18.34-10.6,0-16.72,5.91-17.12,15.69H773.38c1-19.77,15.28-35.67,44.84-35.67C847.56,178.43,862.65,192.29,862.65,219.4Zm-27.52,18.34c-6.11.41-14.67,1.22-20.79,2.24-11.82,2-16.71,5.91-16.71,14.27,0,7.74,5.3,13,15.29,13,5.91,0,12.23-1.83,16.3-5.91,4.89-4.89,5.91-10.39,5.91-19.77Z"/><path class="cls-1" d="M949.47,285.23V271.57h-.41c-6.32,10.6-17.73,16.31-29.75,16.31-26.09,0-43-21.4-43-54.42S893,179,918.9,179c11.82,0,23,5.3,29.35,15.09h.4v-54h28.54V285.23Zm-43.41-51.77c0,19.77,8.76,32.61,22.42,32.61,12.84,0,21.6-12,21.6-32.61s-8.76-32.61-21.6-32.61C914.82,200.85,906.06,213.69,906.06,233.46Z"/><path class="cls-1" d="M1091.12,285.23V222.66H1031.6v62.57h-30V140.12h30V197h59.52V140.12h30V285.23Z"/><path class="cls-1" d="M1140.47,245.28V181.69H1169v60.74c0,15.69,6.93,22.83,18.14,22.83,11.82,0,20.38-9.38,20.38-28.13V181.69h28.54V285.23h-26.7V272.18H1209a36.83,36.83,0,0,1-30.37,15.49C1155.35,287.67,1140.47,273.41,1140.47,245.28Z"/><path class="cls-1" d="M1285.25,194.13c6.32-9.79,17.53-15.09,29.35-15.09,25.88,0,42.59,21.4,42.59,54.42s-16.91,54.42-43,54.42c-12,0-23.44-5.71-29.76-16.31h-.4v13.66h-27.72V140.12h28.53v54Zm-1.84,39.33c0,20.59,8.77,32.61,21.61,32.61,13.65,0,22.42-12.84,22.42-32.61s-8.77-32.61-22.42-32.61C1292.18,200.85,1283.41,212.88,1283.41,233.46Z"/><path class="cls-1" d="M347.39,46.33q7.74,6.14,15,13.1l-8.78,8.77q-5-4.76-10.24-9.13c-1.59-1.33-3.2-2.62-4.83-3.9Z"/><path class="cls-1" d="M401.22,20.6l-31,31q-7.18-6.88-15-13.14L386.41,7.32Q394.06,13.68,401.22,20.6Z"/><path class="cls-1" d="M369.13,66.15Q376,73.31,382,80.92l-8.83,8.83,0,0c-1.25-1.59-2.52-3.16-3.83-4.7-2.89-3.47-5.88-6.84-9-10.09Z"/><path class="cls-1" d="M421.05,41.91,389.89,73.07q-6.15-7.63-13-14.72l31-31Q414.78,34.37,421.05,41.91Z"/><path class="cls-1" d="M318,75.68,90.76,302.91l-.22-2.14c.33-1.52.67-3,1-4.54,2.54-12.68,6.63-25.26,7.25-38a437.65,437.65,0,0,0-1.34-57.36c-1-11.81-4.46-23.47-7.44-35a158.57,158.57,0,0,0-7.41-20.92c-3.67-8.83-7.62-17.58-12-26.08l-.31-.57a170.45,170.45,0,0,0-11.67,20.34c1.93,4.17,4.61,8.17,6.52,12.41a106.13,106.13,0,0,1,4.21,10.65c.48,1.44.92,2.88,1.31,4.32.72,2.69,1.48,5.38,2.24,8.06,2.21,7.84,4.37,15.7,5.25,23.71,1.72,15.68,2,31.54,2.18,47.34a105.93,105.93,0,0,1-2.25,22.6c-1.71,8.27-3.94,16.32-5.94,25.2a126.45,126.45,0,0,0,7.73,26.51c.57,1.46,1.12,2.83,1.63,4.22.24.61.8,1.9,1.53,3.54,1.79,2.08,3.63,4.11,5.53,6.11L333.22,88.55A166.94,166.94,0,0,0,318,75.68Z"/><path class="cls-1" d="M358.35,263.66c-.12-.49-.24-1-.34-1.45-.47-2.06-1-4.12-1.44-6.18-3.39-14.19-7.09-28.34-8.95-42.73-1.49-11.67.2-23.81.87-35.7A186.82,186.82,0,0,1,351,154.83c1.09-6.11,2.4-9.33,3.76-15.41a86.42,86.42,0,0,0,1-12.13,125.08,125.08,0,0,0-5.69-17.15c-.58-1.46-1.13-2.84-1.64-4.22-.15-.41-.45-1.1-.84-2-1.62-2-3.3-3.89-5-5.79-.88-1-1.77-1.93-2.68-2.88L95.25,340a174.73,174.73,0,0,0,15,12.7L337.48,125.44l-.7,2.74a1.54,1.54,0,0,0,.13-.12c-.42,2.8-.68,5.65-1.3,8.42-1.74,7.87-4.28,15.63-5.31,23.59-.1.89-.21,1.77-.32,2.66-1.31,11.14-1.85,22.56-3,36.51,1.29,10.47,2.12,23.93,4.77,37a336.53,336.53,0,0,0,11.36,41.33c3.63,10.69,6.62,16.56,11.57,26.73a38.51,38.51,0,0,0,3.95,5.61,169.62,169.62,0,0,0,11-19.19c-1.85-5.13-5.23-9.9-7.41-15A79.37,79.37,0,0,1,358.35,263.66Z"/><path class="cls-1" d="M38.45,355.22q6.24,7.78,13.13,15l-31,31Q13.67,394,7.29,386.38Z"/><path class="cls-1" d="M68.17,353.6l-8.77,8.77q-7-7.26-13.09-15l8.84-8.85C59.24,343.77,63.6,348.8,68.17,353.6Z"/><path class="cls-1" d="M58.31,376.91q7.08,6.81,14.73,13L41.89,421q-7.53-6.27-14.59-13.09Z"/><path class="cls-1" d="M89.72,373.19,80.88,382c-1.88-1.49-3.74-3-5.58-4.6-3.12-2.67-6.19-5.44-9.18-8.32l8.78-8.79Q82,367.1,89.72,373.19Z"/><path class="cls-1" d="M264.06,228.65l0,0-8.28-8.25-13.93,13.94,8.26,8.26,6.73-6.73-6.72,6.73h0l90.28,90.29h0q3.29-3.48,6.35-7.11,3.38-4,6.5-8.2Z"/><path class="cls-1" d="M321.87,327.83l-.06-.06-78.44-78.43-8.26-8.26-15.84,15.83c2.38,2.31,5.21,5.09,8.36,8.17,7.38,7.22,72.59,71.2,73.45,72.38-1,0-28-11.86-87.59-8.73l-3.81.21a197.26,197.26,0,0,0-58.83,12.92,176.32,176.32,0,0,0-32.62,16.49,168.39,168.39,0,0,0,18.44,10.73h0a180.81,180.81,0,0,1,24.73-9.92h0c3.19-1,6.63-2,10.28-3a208.61,208.61,0,0,1,41.77-6.76l.23,0c45.43-2.6,69.11,3.75,81.67,6.93a125.13,125.13,0,0,0,22-6.81c1.46-.58,2.84-1.13,4.23-1.64.75-.29,2.54-1.08,4.74-2.08,0,0,1.68-.9,1.83-1q2.82-2.44,5.53-5.06l-8.87-8.93Z"/><path class="cls-1" d="M382.56,347c-4.06,5.13-8.39,10.13-13,14.95l-8.78-8.77c4.55-4.78,8.86-9.8,12.91-15Z"/><path class="cls-1" d="M421.65,386q-6.36,7.68-13.26,14.84l-31-31q6.84-7.17,13-14.94Z"/><path class="cls-1" d="M362.83,368.78a219.19,219.19,0,0,1-16.57,14.4c-3.1-3.05-6.1-6-8.94-8.79A202.93,202.93,0,0,0,354.05,360Z"/><path class="cls-1" d="M401.65,407.6q-7.71,7.48-16,14.35c-7-6.95-19.24-19-31.43-31q8.56-6.8,16.45-14.38Z"/><path class="cls-1" d="M179,184.88l-90-90s0,0,0,0c-2.19,2.3-4.33,4.66-6.39,7.06-2.56,3-5,6.08-7.36,9.24L158,192h0l6.08,5.91h0l9.09,8.85L187,192.91l-8-8Z"/><path class="cls-1" d="M290.41,58.78c-3.37,1.62-8.16,3.76-14.16,6h0A208.41,208.41,0,0,1,252.83,72h0A209.06,209.06,0,0,1,215,77.74l-1.47.07c-37.54,2-61.83-2.72-75.38-5.94h0c-15,2.57-22.15,5-26.46,6.44a65.84,65.84,0,0,0-11.86,6.2l-1.2,1.06c-1,.86-1.89,1.72-2.82,2.61h0l12.3,12.31.59.57,70.15,70.15h0l1.13,1.13,5.81,5.81h0l8,8,.84-.86,5.89-5.88,9.18-9.18c-.9-.89-4.16-4.06-8.82-8.61-9.3-9.08-72.74-71.2-73.28-72,1-.07,27.42,11.63,85.92,8.8,1.8-.08,3.64-.17,5.5-.3,45.58-2.83,78.3-21,90.25-28.62A170.52,170.52,0,0,0,290.41,58.78Z"/><path class="cls-1" d="M52.06,57.94Q44.94,65.31,38.53,73.3L7,42.55q6.69-8.09,14-15.62Z"/><path class="cls-1" d="M68.64,74.52A197.83,197.83,0,0,0,55.4,89.77L46.46,81c1.37-1.73,2.77-3.43,4.2-5.12q4.41-5.19,9.2-10.17Z"/><path class="cls-1" d="M75.34,36.91q-8.61,6.75-16.53,14.31l-31-31q7.76-7.46,16.08-14.27C50.36,12.38,62.77,24.57,75.34,36.91Z"/><path class="cls-1" d="M92.25,53.48A198.39,198.39,0,0,0,75.39,67.81L66.61,59A217.76,217.76,0,0,1,83.29,44.69Z"/><path class="cls-1" d="M382,80.92Q376,73.32,369.13,66.15c-1.09-1.13-2.19-2.26-3.31-3.37s-2.27-2.25-3.42-3.35q-7.27-7-15-13.1-6.84-5.44-14-10.24c-.09-.06-.2-.14-.31-.2l-1.54-1L329.9,33.8c-.65-.42-1.3-.82-1.95-1.23C252.72-14.58,154.59-10.54,83.29,44.69A217.76,217.76,0,0,0,66.61,59c-1.3,1.24-2.57,2.49-3.84,3.76-1,1-2,2-2.91,3q-4.8,5-9.2,10.17c-1.43,1.69-2.83,3.39-4.2,5.12a212.35,212.35,0,0,0-20.94,31.73c-1.45,2.7-2.85,5.42-4.17,8.16-35.19,72.71-26.88,161.19,25,226.44q6.11,7.72,13.09,15c.92,1,1.86,1.94,2.81,2.9l.56.56c1.1,1.11,2.22,2.21,3.35,3.28,3,2.88,6.06,5.65,9.18,8.32,1.84,1.57,3.7,3.11,5.58,4.6a214.47,214.47,0,0,0,221.79,27.56L304,409c1-.45,2-.91,2.94-1.38l2.37-1.15a214.15,214.15,0,0,0,37-23.3,219.19,219.19,0,0,0,16.57-14.4c1-1,2-2,3-2.95,1.27-1.27,2.52-2.54,3.75-3.84,4.6-4.82,8.93-9.82,13-14.95A214.36,214.36,0,0,0,382,80.92Zm-32.12,269c-.11.12-.22.22-.33.32-2.76,2-19.65,9.76-22.21,10.7-9.06,3.32-22,10.33-59.79,13.39-10.21.83-22.31,1.31-36.77,1.27-40.77-.15-39.56-4.13-57.42-4.18a54.56,54.56,0,0,0-5.84.32h0q-1.59.69-3.18,1.44-5.31,2.46-10.3,5.41c11.79,3.31,29.4,10.34,59.18,12.87,24.5,2.07,47.85.8,60.65-.11,2.28-.17,4.23-.31,5.79-.44,1.85-.14,5.4-.33,12.6-1.34-1.92.86-3.85,1.69-5.81,2.48q-4.62,1.86-9.31,3.5a191.59,191.59,0,0,1-198-45.12c-2.57-4.31-9.3-19-10.18-21.4C65.7,320,58.69,307,55.63,269.25c-.84-10.2-1.31-22.31-1.27-36.77.15-40.76,4.12-39.56,4.18-57.41,0-1.34-.06-2.68-.16-4-.86-2.18-1.8-4.34-2.79-6.48q-2-4.32-4.34-8.43C47.9,167.92,41,185.47,38.5,214.91c-2.08,24.5-.81,47.86.11,60.65.16,2.29.31,4.23.43,5.79.17,2,.37,6,1.63,14.56-1.46-3.09-2.83-6.24-4.13-9.42q-2.32-5.73-4.26-11.57a192.65,192.65,0,0,1,4.26-132.8c.64-1.58,1.31-3.16,2-4.72q2-4.52,4.17-8.9A190.64,190.64,0,0,1,77.79,79.59c2.37-1.87,19.72-9.83,22.32-10.78,9-3.33,22-10.34,59.79-13.4,10.2-.83,22.31-1.31,36.77-1.27,40.76.15,39.55,4.13,57.41,4.18,1.47,0,2.93-.06,4.38-.18h0q3-1.23,6-2.62,4.44-2.07,8.63-4.46c-11.78-3.33-29.34-10.28-58.88-12.77-24.5-2.08-47.86-.81-60.65.1-2.29.17-4.23.31-5.79.44-2,.16-6.05.37-14.64,1.64q4.43-2.07,9-3.92,4.75-1.94,9.59-3.59A191.58,191.58,0,0,1,349.92,78.68l1,1c2.5,4.08,9.39,19.17,10.27,21.57,3.32,9.06,10.33,22,13.39,59.79.84,10.2,1.32,22.31,1.27,36.77-.14,40.76-4.12,39.56-4.17,57.41,0,1.54.06,3.08.2,4.61v0c.54,1.25,1.09,2.49,1.67,3.73Q376,268.94,379,274c3.37-11.78,10.22-29.3,12.69-58.59,2.08-24.5.81-47.85-.11-60.65-.16-2.29-.3-4.23-.43-5.79-.14-1.78-.32-5.17-1.24-11.9.74,1.68,1.47,3.38,2.16,5.09.79,2,1.56,3.92,2.28,5.9a191.67,191.67,0,0,1-44.42,201.91Z"/></g></g></svg>
        </router-link>
      </div>
      <div class="main-menu small">
        <div class="menu-1">
          <router-link class="link l-scroll eff-base eff-1 eff-active" :class="{'white eff-w' : homePage, 'eff-b' : !homePage}" to="/challenge">
            Challenge
          </router-link>
        </div>
        <div class="menu-2">
          <router-link class="link l-scroll eff-base eff-1 eff-active" :class="{'white eff-w' : homePage, 'eff-b' : !homePage}" to="/solution">
            Solution
          </router-link>
        </div>
        <div class="menu-3">
          <router-link class="link l-scroll eff-base eff-1 eff-active" :class="{'white eff-w' : homePage, 'eff-b' : !homePage}" to="/journey">
            Journey
          </router-link>
        </div>
        <div class="menu-4">
          <router-link class="link l-scroll eff-base eff-1 eff-active" :class="{'white eff-w' : homePage, 'eff-b' : !homePage}" to="/business">
            Business
          </router-link>
        </div>
        <div class="menu-5">
          <router-link class="link" to="/contact">
            <button id="c-button" class="small" :class="{'m-home': homePage}">Contact</button>
          </router-link>
        </div>
      </div>
      <div class="hamburger-container" :class="{'hamburger-home': homePage}" @click="showNav">
        <div id="hamburger" class="hamburger" :class="showOverlay ? 'play' : 'collapse'" :style="'background-image: url('+hamburger()+')'" alt="Hamburger"></div>
      </div>
      <div class="overlay-container" :class="{'show': showOverlay}">
        <div class="nav-logo">
          <router-link class="link" to="/">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1357.19 428.61" fill="#0090D1" class="svg-logo"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M589.49,140.12c36.48,0,53,15.08,53,41,0,17.73-10.19,31-26.49,35.46V217c10.19,3.67,15.08,9.79,21.81,28.13l14.47,40.15H619.66L608,250.78c-5.3-15.48-11.21-21-25.48-21H566.05v55.44h-30V140.12ZM566.05,206h21.2c18.14,0,25.07-8.16,25.07-21.4,0-14.07-9.58-20.18-26.7-20.18H566.05Z"/><path class="cls-1" d="M760.08,233.46c0,33.63-20.58,55-53,55s-53-21.4-53-55,20.58-55,53-55S760.08,199.83,760.08,233.46Zm-76,0c0,20.18,9,33,23,33s23-12.84,23-33-9-33-23-33S684.06,213.28,684.06,233.46Z"/><path class="cls-1" d="M862.65,219.4v37.5c0,13,1,21.4,2.85,28.33H839.82a59.08,59.08,0,0,1-1.43-13.86H838c-7.75,11-19.37,16.3-33.63,16.3-22,0-35.26-13.45-35.26-31.38,0-16.92,10.19-28.33,40.15-33,7.74-1.22,19.36-2.45,25.88-2.85v-3.67c0-13.05-6.93-18.34-16.91-18.34-10.6,0-16.72,5.91-17.12,15.69H773.38c1-19.77,15.28-35.67,44.84-35.67C847.56,178.43,862.65,192.29,862.65,219.4Zm-27.52,18.34c-6.11.41-14.67,1.22-20.79,2.24-11.82,2-16.71,5.91-16.71,14.27,0,7.74,5.3,13,15.29,13,5.91,0,12.23-1.83,16.3-5.91,4.89-4.89,5.91-10.39,5.91-19.77Z"/><path class="cls-1" d="M949.47,285.23V271.57h-.41c-6.32,10.6-17.73,16.31-29.75,16.31-26.09,0-43-21.4-43-54.42S893,179,918.9,179c11.82,0,23,5.3,29.35,15.09h.4v-54h28.54V285.23Zm-43.41-51.77c0,19.77,8.76,32.61,22.42,32.61,12.84,0,21.6-12,21.6-32.61s-8.76-32.61-21.6-32.61C914.82,200.85,906.06,213.69,906.06,233.46Z"/><path class="cls-1" d="M1091.12,285.23V222.66H1031.6v62.57h-30V140.12h30V197h59.52V140.12h30V285.23Z"/><path class="cls-1" d="M1140.47,245.28V181.69H1169v60.74c0,15.69,6.93,22.83,18.14,22.83,11.82,0,20.38-9.38,20.38-28.13V181.69h28.54V285.23h-26.7V272.18H1209a36.83,36.83,0,0,1-30.37,15.49C1155.35,287.67,1140.47,273.41,1140.47,245.28Z"/><path class="cls-1" d="M1285.25,194.13c6.32-9.79,17.53-15.09,29.35-15.09,25.88,0,42.59,21.4,42.59,54.42s-16.91,54.42-43,54.42c-12,0-23.44-5.71-29.76-16.31h-.4v13.66h-27.72V140.12h28.53v54Zm-1.84,39.33c0,20.59,8.77,32.61,21.61,32.61,13.65,0,22.42-12.84,22.42-32.61s-8.77-32.61-22.42-32.61C1292.18,200.85,1283.41,212.88,1283.41,233.46Z"/><path class="cls-1" d="M347.39,46.33q7.74,6.14,15,13.1l-8.78,8.77q-5-4.76-10.24-9.13c-1.59-1.33-3.2-2.62-4.83-3.9Z"/><path class="cls-1" d="M401.22,20.6l-31,31q-7.18-6.88-15-13.14L386.41,7.32Q394.06,13.68,401.22,20.6Z"/><path class="cls-1" d="M369.13,66.15Q376,73.31,382,80.92l-8.83,8.83,0,0c-1.25-1.59-2.52-3.16-3.83-4.7-2.89-3.47-5.88-6.84-9-10.09Z"/><path class="cls-1" d="M421.05,41.91,389.89,73.07q-6.15-7.63-13-14.72l31-31Q414.78,34.37,421.05,41.91Z"/><path class="cls-1" d="M318,75.68,90.76,302.91l-.22-2.14c.33-1.52.67-3,1-4.54,2.54-12.68,6.63-25.26,7.25-38a437.65,437.65,0,0,0-1.34-57.36c-1-11.81-4.46-23.47-7.44-35a158.57,158.57,0,0,0-7.41-20.92c-3.67-8.83-7.62-17.58-12-26.08l-.31-.57a170.45,170.45,0,0,0-11.67,20.34c1.93,4.17,4.61,8.17,6.52,12.41a106.13,106.13,0,0,1,4.21,10.65c.48,1.44.92,2.88,1.31,4.32.72,2.69,1.48,5.38,2.24,8.06,2.21,7.84,4.37,15.7,5.25,23.71,1.72,15.68,2,31.54,2.18,47.34a105.93,105.93,0,0,1-2.25,22.6c-1.71,8.27-3.94,16.32-5.94,25.2a126.45,126.45,0,0,0,7.73,26.51c.57,1.46,1.12,2.83,1.63,4.22.24.61.8,1.9,1.53,3.54,1.79,2.08,3.63,4.11,5.53,6.11L333.22,88.55A166.94,166.94,0,0,0,318,75.68Z"/><path class="cls-1" d="M358.35,263.66c-.12-.49-.24-1-.34-1.45-.47-2.06-1-4.12-1.44-6.18-3.39-14.19-7.09-28.34-8.95-42.73-1.49-11.67.2-23.81.87-35.7A186.82,186.82,0,0,1,351,154.83c1.09-6.11,2.4-9.33,3.76-15.41a86.42,86.42,0,0,0,1-12.13,125.08,125.08,0,0,0-5.69-17.15c-.58-1.46-1.13-2.84-1.64-4.22-.15-.41-.45-1.1-.84-2-1.62-2-3.3-3.89-5-5.79-.88-1-1.77-1.93-2.68-2.88L95.25,340a174.73,174.73,0,0,0,15,12.7L337.48,125.44l-.7,2.74a1.54,1.54,0,0,0,.13-.12c-.42,2.8-.68,5.65-1.3,8.42-1.74,7.87-4.28,15.63-5.31,23.59-.1.89-.21,1.77-.32,2.66-1.31,11.14-1.85,22.56-3,36.51,1.29,10.47,2.12,23.93,4.77,37a336.53,336.53,0,0,0,11.36,41.33c3.63,10.69,6.62,16.56,11.57,26.73a38.51,38.51,0,0,0,3.95,5.61,169.62,169.62,0,0,0,11-19.19c-1.85-5.13-5.23-9.9-7.41-15A79.37,79.37,0,0,1,358.35,263.66Z"/><path class="cls-1" d="M38.45,355.22q6.24,7.78,13.13,15l-31,31Q13.67,394,7.29,386.38Z"/><path class="cls-1" d="M68.17,353.6l-8.77,8.77q-7-7.26-13.09-15l8.84-8.85C59.24,343.77,63.6,348.8,68.17,353.6Z"/><path class="cls-1" d="M58.31,376.91q7.08,6.81,14.73,13L41.89,421q-7.53-6.27-14.59-13.09Z"/><path class="cls-1" d="M89.72,373.19,80.88,382c-1.88-1.49-3.74-3-5.58-4.6-3.12-2.67-6.19-5.44-9.18-8.32l8.78-8.79Q82,367.1,89.72,373.19Z"/><path class="cls-1" d="M264.06,228.65l0,0-8.28-8.25-13.93,13.94,8.26,8.26,6.73-6.73-6.72,6.73h0l90.28,90.29h0q3.29-3.48,6.35-7.11,3.38-4,6.5-8.2Z"/><path class="cls-1" d="M321.87,327.83l-.06-.06-78.44-78.43-8.26-8.26-15.84,15.83c2.38,2.31,5.21,5.09,8.36,8.17,7.38,7.22,72.59,71.2,73.45,72.38-1,0-28-11.86-87.59-8.73l-3.81.21a197.26,197.26,0,0,0-58.83,12.92,176.32,176.32,0,0,0-32.62,16.49,168.39,168.39,0,0,0,18.44,10.73h0a180.81,180.81,0,0,1,24.73-9.92h0c3.19-1,6.63-2,10.28-3a208.61,208.61,0,0,1,41.77-6.76l.23,0c45.43-2.6,69.11,3.75,81.67,6.93a125.13,125.13,0,0,0,22-6.81c1.46-.58,2.84-1.13,4.23-1.64.75-.29,2.54-1.08,4.74-2.08,0,0,1.68-.9,1.83-1q2.82-2.44,5.53-5.06l-8.87-8.93Z"/><path class="cls-1" d="M382.56,347c-4.06,5.13-8.39,10.13-13,14.95l-8.78-8.77c4.55-4.78,8.86-9.8,12.91-15Z"/><path class="cls-1" d="M421.65,386q-6.36,7.68-13.26,14.84l-31-31q6.84-7.17,13-14.94Z"/><path class="cls-1" d="M362.83,368.78a219.19,219.19,0,0,1-16.57,14.4c-3.1-3.05-6.1-6-8.94-8.79A202.93,202.93,0,0,0,354.05,360Z"/><path class="cls-1" d="M401.65,407.6q-7.71,7.48-16,14.35c-7-6.95-19.24-19-31.43-31q8.56-6.8,16.45-14.38Z"/><path class="cls-1" d="M179,184.88l-90-90s0,0,0,0c-2.19,2.3-4.33,4.66-6.39,7.06-2.56,3-5,6.08-7.36,9.24L158,192h0l6.08,5.91h0l9.09,8.85L187,192.91l-8-8Z"/><path class="cls-1" d="M290.41,58.78c-3.37,1.62-8.16,3.76-14.16,6h0A208.41,208.41,0,0,1,252.83,72h0A209.06,209.06,0,0,1,215,77.74l-1.47.07c-37.54,2-61.83-2.72-75.38-5.94h0c-15,2.57-22.15,5-26.46,6.44a65.84,65.84,0,0,0-11.86,6.2l-1.2,1.06c-1,.86-1.89,1.72-2.82,2.61h0l12.3,12.31.59.57,70.15,70.15h0l1.13,1.13,5.81,5.81h0l8,8,.84-.86,5.89-5.88,9.18-9.18c-.9-.89-4.16-4.06-8.82-8.61-9.3-9.08-72.74-71.2-73.28-72,1-.07,27.42,11.63,85.92,8.8,1.8-.08,3.64-.17,5.5-.3,45.58-2.83,78.3-21,90.25-28.62A170.52,170.52,0,0,0,290.41,58.78Z"/><path class="cls-1" d="M52.06,57.94Q44.94,65.31,38.53,73.3L7,42.55q6.69-8.09,14-15.62Z"/><path class="cls-1" d="M68.64,74.52A197.83,197.83,0,0,0,55.4,89.77L46.46,81c1.37-1.73,2.77-3.43,4.2-5.12q4.41-5.19,9.2-10.17Z"/><path class="cls-1" d="M75.34,36.91q-8.61,6.75-16.53,14.31l-31-31q7.76-7.46,16.08-14.27C50.36,12.38,62.77,24.57,75.34,36.91Z"/><path class="cls-1" d="M92.25,53.48A198.39,198.39,0,0,0,75.39,67.81L66.61,59A217.76,217.76,0,0,1,83.29,44.69Z"/><path class="cls-1" d="M382,80.92Q376,73.32,369.13,66.15c-1.09-1.13-2.19-2.26-3.31-3.37s-2.27-2.25-3.42-3.35q-7.27-7-15-13.1-6.84-5.44-14-10.24c-.09-.06-.2-.14-.31-.2l-1.54-1L329.9,33.8c-.65-.42-1.3-.82-1.95-1.23C252.72-14.58,154.59-10.54,83.29,44.69A217.76,217.76,0,0,0,66.61,59c-1.3,1.24-2.57,2.49-3.84,3.76-1,1-2,2-2.91,3q-4.8,5-9.2,10.17c-1.43,1.69-2.83,3.39-4.2,5.12a212.35,212.35,0,0,0-20.94,31.73c-1.45,2.7-2.85,5.42-4.17,8.16-35.19,72.71-26.88,161.19,25,226.44q6.11,7.72,13.09,15c.92,1,1.86,1.94,2.81,2.9l.56.56c1.1,1.11,2.22,2.21,3.35,3.28,3,2.88,6.06,5.65,9.18,8.32,1.84,1.57,3.7,3.11,5.58,4.6a214.47,214.47,0,0,0,221.79,27.56L304,409c1-.45,2-.91,2.94-1.38l2.37-1.15a214.15,214.15,0,0,0,37-23.3,219.19,219.19,0,0,0,16.57-14.4c1-1,2-2,3-2.95,1.27-1.27,2.52-2.54,3.75-3.84,4.6-4.82,8.93-9.82,13-14.95A214.36,214.36,0,0,0,382,80.92Zm-32.12,269c-.11.12-.22.22-.33.32-2.76,2-19.65,9.76-22.21,10.7-9.06,3.32-22,10.33-59.79,13.39-10.21.83-22.31,1.31-36.77,1.27-40.77-.15-39.56-4.13-57.42-4.18a54.56,54.56,0,0,0-5.84.32h0q-1.59.69-3.18,1.44-5.31,2.46-10.3,5.41c11.79,3.31,29.4,10.34,59.18,12.87,24.5,2.07,47.85.8,60.65-.11,2.28-.17,4.23-.31,5.79-.44,1.85-.14,5.4-.33,12.6-1.34-1.92.86-3.85,1.69-5.81,2.48q-4.62,1.86-9.31,3.5a191.59,191.59,0,0,1-198-45.12c-2.57-4.31-9.3-19-10.18-21.4C65.7,320,58.69,307,55.63,269.25c-.84-10.2-1.31-22.31-1.27-36.77.15-40.76,4.12-39.56,4.18-57.41,0-1.34-.06-2.68-.16-4-.86-2.18-1.8-4.34-2.79-6.48q-2-4.32-4.34-8.43C47.9,167.92,41,185.47,38.5,214.91c-2.08,24.5-.81,47.86.11,60.65.16,2.29.31,4.23.43,5.79.17,2,.37,6,1.63,14.56-1.46-3.09-2.83-6.24-4.13-9.42q-2.32-5.73-4.26-11.57a192.65,192.65,0,0,1,4.26-132.8c.64-1.58,1.31-3.16,2-4.72q2-4.52,4.17-8.9A190.64,190.64,0,0,1,77.79,79.59c2.37-1.87,19.72-9.83,22.32-10.78,9-3.33,22-10.34,59.79-13.4,10.2-.83,22.31-1.31,36.77-1.27,40.76.15,39.55,4.13,57.41,4.18,1.47,0,2.93-.06,4.38-.18h0q3-1.23,6-2.62,4.44-2.07,8.63-4.46c-11.78-3.33-29.34-10.28-58.88-12.77-24.5-2.08-47.86-.81-60.65.1-2.29.17-4.23.31-5.79.44-2,.16-6.05.37-14.64,1.64q4.43-2.07,9-3.92,4.75-1.94,9.59-3.59A191.58,191.58,0,0,1,349.92,78.68l1,1c2.5,4.08,9.39,19.17,10.27,21.57,3.32,9.06,10.33,22,13.39,59.79.84,10.2,1.32,22.31,1.27,36.77-.14,40.76-4.12,39.56-4.17,57.41,0,1.54.06,3.08.2,4.61v0c.54,1.25,1.09,2.49,1.67,3.73Q376,268.94,379,274c3.37-11.78,10.22-29.3,12.69-58.59,2.08-24.5.81-47.85-.11-60.65-.16-2.29-.3-4.23-.43-5.79-.14-1.78-.32-5.17-1.24-11.9.74,1.68,1.47,3.38,2.16,5.09.79,2,1.56,3.92,2.28,5.9a191.67,191.67,0,0,1-44.42,201.91Z"/></g></g></svg>
          </router-link>
        </div>
        <ul class="nav-list">
          <li class="nav-item-container" @click="slowClick()">
            <div class="nav-item-wrapper m-b">
              <router-link class="link h5 nav-1 eff-base eff-2 eff-b eff-active" to="/challenge">
                Challenge
              </router-link>
            </div>
          </li>
          <li class="nav-item-container" @click="slowClick()">
              <div class="nav-item-wrapper m-b">
                <router-link class="link h5 nav-1 eff-base eff-2 eff-b eff-active" to="/solution">
                  Solution
                </router-link>
              </div>
          </li>
          <li class="nav-item-container" @click="slowClick()">
              <div class="nav-item-wrapper m-b">
                <router-link class="link h5 nav-1 eff-base eff-2 eff-b eff-active" to="/journey">
                  Journey
                </router-link>
              </div>
          </li>
          <li class="nav-item-container li-right" @click="slowClick()">
              <div class="nav-item-wrapper m-b">
                <router-link class="link h5 nav-1 eff-base eff-2 eff-b eff-active" to="/business">
                  Business
                </router-link>
              </div>
          </li>
          <li class="nav-item-container li-right" @click="slowClick()">
              <div class="nav-item-wrapper">
                <router-link class="link h5 nav-1 eff-base eff-2 eff-b eff-active" to="/contact">
                  Contact
                </router-link>
              </div>
          </li>
        </ul>
        <div class="overlay-footer" :class="{'show': showOverlay}">
          <ul class="f-social">
            <li><a class="link eff-base-r eff-1 eff-b" :href="prefix+decoded">Email</a></li>
            <li class="f-link"><a class="link eff-base-r eff-1 eff-b spc" href="https://www.linkedin.com" target="_blank" rel="noopener">LinkedIn</a></li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import HamburgerSprite from '../assets/hamburger-sprite-a.svg'
import HamburgerSpriteAlt from '../assets/hamburger-sprite-b.svg'

export default {
  name: 'NavHeaderAlt',
  data () {
    return {
      homePage: true,
      showOverlay: false,
      hamburgericon: HamburgerSprite,
      hamburgericonalt: HamburgerSpriteAlt,
      decoded: atob('aW5mb0BzcGlyYWwtcmluZy1pbnRlcmNoYW5nZS5jb20='),
      prefix: atob('bWFpbHRvOg==')
    }
  },
  methods: {
    showNav () {
      this.showOverlay = !this.showOverlay
    },
    colorAttr () {
      const homeColor = '#F0F0F0'
      const normalColor = '#0090D1'
      if (this.homePage) return homeColor
      return normalColor
    },
    hamburger () {
      const homeIcon = this.hamburgericon
      const altIcon = this.hamburgericonalt
      if (this.homePage) return homeIcon
      return altIcon
    },
    slowClick () {
      setTimeout(function () {
        this.showOverlay = false
      }.bind(this), 200)
    },
    toTop () {
      if (this.$route.path === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  },
  watch: {
    showOverlay: function (watchOverlay) {
      var className = 'overlay-open'
      if (watchOverlay) {
        document.body.classList.add(className)
        // close-overlay-media
      } else {
        document.body.classList.remove(className)
      }
    },
    $route: function () {
      if (this.$route.path === '/') /* (this.$route.path === '/' || this.$route.path === '/business') */ {
        this.homePage = true
      } else {
        this.homePage = false
      }
    }
  },
  mounted () {
    var doc = document.documentElement
    var w = window

    var prevScroll = w.scrollY || doc.scrollTop
    var curScroll
    var direction = 0
    var prevDirection = 0

    var header = document.getElementById('navbar')

    var checkScroll = function () {
      curScroll = w.scrollY || doc.scrollTop
      if (curScroll > prevScroll) {
        // scrolled up
        direction = 2
      } else if (curScroll < prevScroll) {
        // scrolled down
        direction = 1
      } if (direction !== prevDirection) {
        toggleHeader(direction, curScroll)
      }
      prevScroll = curScroll
    }

    var toggleHeader = function (direction, curScroll) {
      if (direction === 2 && curScroll > 96) {
        header.classList.add('hide')
        prevDirection = direction
      } else if (direction === 1) {
        header.classList.remove('hide')
        prevDirection = direction
      }
    }
    window.addEventListener('scroll', checkScroll)

    // scroll
    const debounce = (fn) => {
      let frame
      return (...params) => {
        if (frame) {
          cancelAnimationFrame(frame)
        }
        frame = requestAnimationFrame(() => {
          fn(...params)
        })
      }
    }
    const storeScroll = () => {
      document.documentElement.dataset.scroll = window.scrollY
    }
    document.addEventListener('scroll', debounce(storeScroll), { passive: true })
    storeScroll()

    // close overlay media
    const mediaQuery = window.matchMedia('(min-width: 1025px)')
    const handleMediaQuery = (e) => {
      if (e.matches) {
        this.showOverlay = false
      }
    }
    mediaQuery.addListener(handleMediaQuery)
    handleMediaQuery(mediaQuery)
  }
}
</script>

<style lang="scss" scoped>
html:not([data-scroll='0']) .navbar {
  background: white;
}

html:not([data-scroll='0']) .l-scroll {
  color: $c-a !important;
}

html:not([data-scroll='0']) .m-home {
  color: $c-a !important;
  border: 1px solid $c-a !important;
  &:hover {
    color: $c-w !important;
    background: $c-e !important;
    border: 1px solid $c-e !important;
  }
}

html:not([data-scroll='0']) .svg-logo {
  fill: $c-e !important;
}

html:not([data-scroll='0']) #hamburger {
  background-image: url('../assets/hamburger-sprite-b.svg') !important;
}

html:not([data-scroll='0']) .eff-base:after {
  background: $c-a !important;
}

.logo-show {
  display: none;
}
.header {
  width: 100%;
  position: absolute;
}
.navbar.hide {
  top: -97px;
  transition: all 0.5s ease;
}
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  @include grid;
  height: 96px;
  align-items: center;
  background: none;
  transition: all 0.3s ease;
  @include tablet {
    height: 85px;
  }
  .logo {
    grid-column: 2 / 3;
    grid-row: 1;
    z-index: 50;
    a {
      display: block;
      height: 46px;
      width: 137px;
      .svg-logo {
        height: 46px;
        width: 137px;
      }
    }
  }
  .main-menu {
    grid-column: 8 / 13;
    grid-row: 1;
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include laptop {
      grid-column: 8 / 14;
    }
    @include tablet {
      display: none;
    }
    .menu-1, .menu-2, .menu-3, .menu-4, .menu-5 {
      padding-top: 3px;
    }
    button {
      color: $c-a;
      background: none;
      width: 104px;
      height: 32px;
      border: 1px solid $c-a;
      border-radius: 16px;
      &:hover {
        color: $c-w;
        background: $c-e;
        border: 1px solid $c-e;
      }
      @include laptop {
        width: 104px;
      }
    }
    .m-home {
      color: $c-h;
      border: 1px solid $c-w;
      &:hover {
        color: $c-h;
        background: $c-e;
        border: 1px solid $c-e;
      }
    }
  }
  .hamburger-container {
    display: none;
    @include tablet {
      grid-column: 9 / 10;
      grid-row: 1 / 2;
      display: block;
      margin-left: auto;
      position: relative;
      width: 27px;
      height: 27px;
      overflow: hidden;
      cursor: pointer;
      z-index: 99;
    }
    @include phone {
      grid-column: 5 / 6;
    }
    .hamburger {
      animation-duration: 300ms;
      animation-timing-function: steps(18);
      width: 27px;
      height: 27px;
      animation-fill-mode: forwards;
      background-repeat: no-repeat;
      transform-origin: 0 0;
      transform: scale(1.125);
    }
  }
}

// overlay
.overlay-container {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  pointer-events: none;
  &.show {
    visibility: visible;
    opacity: 1;
    background-color: $c-w;
    pointer-events: initial;
  }
  .nav-logo {
    position: fixed;
    margin-top: 19px;
    z-index: 100;
    left: 72px;
    @include tablet {
      left: 48px;
    }
    @include phone {
      left: 26px;
    }
    a {
      display: block;
      height: 46px;
      width: 137px;
      .svg-logo {
        height: 46px;
        width: 137px;
      }
    }
  }
  .nav-list {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    z-index: 95;
    left: 72px;
    @include tablet {
      left: 48px;
    }
    @include phone {
      left: 26px;
    }
    @include phone-landscape {
      columns: 2;
      .li-right {
        margin-left: 32px;
      }
    }
    .m-b {
      margin-bottom: 20px;
    }
  }
  .overlay-footer {
    position: fixed;
    width: 100vw;
    left: 0;
    right: 0;
    bottom: 54px;
    @include grid;
    @include phone {
      bottom: 44px;
    }
/*     .f-link {
      grid-column: 10 / 14;
      grid-row: 1 / 2;
      margin-top: auto;
      margin-left: auto;
      @include tablet {
        grid-column: 5 / 10;
      }
      @include phone {
        grid-column: 4 / 6;
      }
    } */
    .f-social {
      grid-column: 2 / 5;
      grid-row: 1 / 2;
      @include phone {
        grid-column: 2 / 4;
      }
      @include xlphone-landscape {
        display: none;
      }
      @include mini {
        display: none;
      }
      .spc {
        margin-top: 12px;
      }
    }
  }
}

// hamburger
@keyframes hamburger {
    0% {
        background-position: 0px 0px;
    }
    100% {
        background-position: -432px 0px;
    }
}

@keyframes hamburger-reverse {
    0% {
        background-position: -432px 0px;
    }
    100% {
        background-position: 0px 0px;
    }
}

.hamburger.play {
    animation-name: hamburger;
}
.hamburger.collapse {
    animation-name: hamburger-reverse;
}

</style>
